import { API_PATH, API_V2_PATH } from '@/shared/constants/api'
import { apiRequest } from '@/shared/helpers/api-request'
import type { User, UserPreferences } from '@/shared/types/global.types'

export function getUser(token: string) {
  return apiRequest<User>(API_V2_PATH.USER, token, 'GET', undefined, 'v2')
}

export function updateUserPreferences(
  token: string,
  preferences: UserPreferences,
) {
  return apiRequest<User>(API_PATH.USER_PREFERENCES, token, 'PUT', preferences)
}
